var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinnner-container"},_vm._l((_vm.spinnerList),function(item,index){return _c('div',{key:index,staticClass:"spinnner-item-box",style:(`transform: ${item.transform}`)},[_c('div',{staticClass:"spinnner-content",style:(`background:${item.background};animation:${item.animation}`)})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }